export interface IPath {
  path: string
}

export interface IPathWithPermission extends IPath {
  permissions?: string[]
}

export enum RoutesKeysGuest {
  ROOT = 'ROOT',
  REGISTER = 'REGISTER',
  ABOUT = 'ABOUT',
  RULES = 'RULES',
  PRIVACY = 'PRIVACY',
  COOKIES = 'COOKIES',
  /** @deprecated Redirect → /rules */
  TERMS = 'TERMS',
  /** @deprecated Redirect → /rules */
  USERAGREEMENT = 'USERAGREEMENT',
  RESTOREACCESS = 'RESTOREACCESS',
  ERROR = 'ERROR',
}

export enum RoutesKeysProfile {
  ROOT = 'ROOT',
  PROJECTS = 'PROJECTS',
  PROJECTPAGE = 'PROJECTPAGE',
  SOCIALORDERS = 'SOCIALORDERS',
  SOCIALORDER = 'SOCIALORDER',
  PROBLEMSSOLUTIONS = 'PROBLEMSSOLUTIONS',
  PROBLEMSOLUTION = 'PROBLEMSOLUTION',
  USERS = 'USERS',
  TEAMS = 'TEAMS',
  TEAMPAGE = 'TEAMPAGE',
  PROJECTMAP = 'PROJECTMAP',
  GROWTHTOOLS = 'GROWTHTOOLS',
  USERCARD = 'USERCARD',
  EVENTS = 'EVENTS',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  PROFILE = 'PROFILE',
  SETTINGS = 'SETTINGS',
  STAFF_REPORTS = 'STAFF_REPORTS',
  ERROR = 'ERROR',
}

export const routesGuest: Record<RoutesKeysGuest, IPathWithPermission> = {
  [RoutesKeysGuest.ROOT]: {
    path: '/',
  },
  [RoutesKeysGuest.REGISTER]: {
    path: 'register',
    permissions: [],
  },
  [RoutesKeysGuest.ABOUT]: {
    path: 'about',
    permissions: [],
  },
  [RoutesKeysGuest.TERMS]: {
    path: 'terms',
    permissions: [],
  },
  [RoutesKeysGuest.RULES]: {
    path: 'rules',
    permissions: [],
  },
  [RoutesKeysGuest.PRIVACY]: {
    path: 'privacy',
    permissions: [],
  },
  [RoutesKeysGuest.COOKIES]: {
    path: 'cookies',
    permissions: [],
  },
  [RoutesKeysGuest.USERAGREEMENT]: {
    path: 'useragreement',
    permissions: [],
  },
  [RoutesKeysGuest.RESTOREACCESS]: {
    path: 'restoreaccess',
    permissions: [],
  },
  [RoutesKeysGuest.ERROR]: {
    path: 'error',
    permissions: [],
  },
}

export const routesProfile: Record<RoutesKeysProfile, IPathWithPermission> = {
  [RoutesKeysProfile.ROOT]: {
    path: '/',
  },
  [RoutesKeysProfile.PROJECTS]: {
    path: 'projects',
    permissions: [],
  },
  [RoutesKeysProfile.PROJECTPAGE]: {
    path: 'projectpage',
    permissions: [],
  },
  [RoutesKeysProfile.SOCIALORDERS]: {
    path: 'socialorders',
    permissions: [],
  },
  [RoutesKeysProfile.SOCIALORDER]: {
    path: 'socialorder',
    permissions: [],
  },
  [RoutesKeysProfile.PROBLEMSSOLUTIONS]: {
    path: 'problemssolutions',
    permissions: [],
  },
  [RoutesKeysProfile.PROBLEMSOLUTION]: {
    path: 'problemsolution',
    permissions: [],
  },
  [RoutesKeysProfile.USERS]: {
    path: 'users',
    permissions: [],
  },
  [RoutesKeysProfile.TEAMS]: {
    path: 'teams',
    permissions: [],
  },
  [RoutesKeysProfile.TEAMPAGE]: {
    path: 'teampage/:id',
    permissions: [],
  },
  [RoutesKeysProfile.PROJECTMAP]: {
    path: 'projectmap',
    permissions: [],
  },
  [RoutesKeysProfile.GROWTHTOOLS]: {
    path: 'growthtools',
    permissions: [],
  },
  [RoutesKeysProfile.USERCARD]: {
    path: 'usercard',
    permissions: [],
  },
  [RoutesKeysProfile.EVENTS]: {
    path: 'events',
    permissions: [],
  },
  [RoutesKeysProfile.RECOMMENDATIONS]: {
    path: 'recommendations',
    permissions: [],
  },
  [RoutesKeysProfile.PROFILE]: {
    path: 'profile',
    permissions: [],
  },
  [RoutesKeysProfile.SETTINGS]: {
    path: 'settings',
    permissions: [],
  },
  [RoutesKeysProfile.STAFF_REPORTS]: {
    path: 'staff/reports',
    permissions: [],
  },
  [RoutesKeysProfile.ERROR]: {
    path: 'error',
    permissions: [],
  },
}
